import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient) { }

  uploadFile(file: File): Observable<{ name: string; url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<{ name: string; url: string }>(`${environment.apiUrl}/media`, formData);
  }
}
